<template>
  <div class="table">
    <div class="table__nav d-flex align-items-center justify-content-end">
      <span class="mb-0 mr-3" v-if="pagination"
        >Page {{ page }} of {{ meta.totalPages }}</span
      >
      <div v-if="pagination" class="table__nav d-flex align-items-center">
        <button
          :style="{ color: primary, 'background-color': secondary }"
          :class="meta.hasPreviousPage ? '' : 'btn-disable'"
          @click="handlePrevPage"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5"
            height="7.688"
            viewBox="0 0 5 7.688"
          >
            <path
              d="M285.983,372.7l-3.8-3.8,1.114-1.114,2.688,2.688,2.771-2.772,1.114,1.114Z"
              transform="translate(372.701 -282.181) rotate(90)"
              :fill="meta.hasPreviousPage ? primary : '#808080'"
            />
          </svg>
        </button>
        <button
          :style="{ color: primary, 'background-color': secondary }"
          :class="meta.hasNextPage ? '' : 'btn-disable'"
          @click="handleNextPage"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5"
            height="7.688"
            viewBox="0 0 5 7.688"
          >
            <path
              d="M285.983,372.7l-3.8-3.8,1.114-1.114,2.688,2.688,2.771-2.772,1.114,1.114Z"
              transform="translate(-367.701 289.869) rotate(-90)"
              :fill="meta.hasNextPage ? primary : '#808080'"
            />
          </svg>
        </button>
      </div>
    </div>
    <datatable
      :headers="tableHeader"
      :headSpacing="headSpacing"
      class="table__content"
    >
      <slot />
    </datatable>
  </div>
</template>

<script>
import Datatable from "@/components/Datatable";
import { mapGetters } from "vuex";

export default {
  name: "custom-table",
  components: {
    Datatable
  },
  props: {
    pagination: {
      type: Boolean,
      default: true
    },
    tableHeader: {
      type: Array,
      default: () => []
    },
    headSpacing: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    meta() {
      return this.GET_META();
    }
  },
  methods: {
    ...mapGetters({
      GET_META: "GET_META"
    }),
    handleNextPage() {
      if (this.meta.hasNextPage) {
        this.$emit("next");
      }
    },
    handlePrevPage() {
      if (this.meta.hasPreviousPage) {
        this.$emit("prev");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  margin-bottom: 60px;
  &__nav {
    button {
      border-radius: 5px;
      border: none;
      cursor: pointer;
      display: block;
      height: 32px;
      margin-right: 10px;
      width: 32px;
      &.btn {
        &-disable {
          cursor: no-drop;
          background-color: #f3f3f3 !important;
        }
      }
    }
    span {
      color: $gray-900;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-xs;
      margin-bottom: 20px;
    }
  }
}
</style>

<style lang="scss">
.table {
  &__content {
    table {
      background-color: $gray-50 !important;
      table-layout: fixed;
    }
    &-action {
      align-items: center;
      display: flex;
      position: relative;
      button {
        border: none;
        height: 23px !important;
        padding: 0.25em;
        transition: all 0.3s ease;
        width: 23px !important;
        &:hover {
          background-color: $gray-250;
        }
        &.btn {
          &-danger {
            background-color: #ef5350 !important;
            &:hover {
              background-color: #c82333 !important;
            }
          }
        }
      }
    }
  }
}
</style>
